<template>
  <div class="tw-grid md:tw-grid-cols-12 tw-grid-cols-1">
    <div class="md:tw-col-span-12 tw-text-center">
      <nav aria-label="Page navigation example">
        <ul class="tw-inline-flex tw-items-center">
          <li>
            <span
              class="tw-w-10 tw-h-10 tw-inline-flex tw-justify-center tw-items-center tw-text-gray-400 tw-bg-white tw-rounded-l-3xl tw-border tw-cursor-pointer border-gradient-hover"
              @click.prevent="changePage(currentPage - 1)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </span>
          </li>
          <li v-for="page in pages" :key="page" style="margin: 0 -1px;">
            <span
              :class="['tw-w-10 tw-h-10 tw-inline-flex tw-justify-center tw-items-center tw-border tw-cursor-pointer', {
                'tw-text-white bg-gradient': page === currentPage,
                'tw-text-gray-400 tw-bg-white': page !== currentPage
              }]"
              @click.prevent="changePage(page)"
            >
              {{ page }}
            </span>
          </li>
          <li>
            <span
              class="tw-w-10 tw-h-10 tw-inline-flex tw-justify-center tw-items-center tw-text-gray-400 tw-bg-white tw-rounded-r-3xl tw-border border-gradient-hover"
              @click.prevent="changePage(currentPage + 1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    calculateTotalPages () {
      return Math.ceil(this.count / 5)
    },
    pages () {
      const totalPages = this.calculateTotalPages
      if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, i) => i + 1)
      } else {
        if (this.currentPage <= 3) {
          return [1, 2, 3, 4, 5]
        } else if (this.currentPage >= totalPages - 2) {
          return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
        } else {
          return [this.currentPage - 2, this.currentPage - 1, this.currentPage, this.currentPage + 1, this.currentPage + 2]
        }
      }
    }
  },
  methods: {
    changePage (page) {
      if (page < 1 || page > this.calculateTotalPages) return
      this.$emit('update', page)
    }
  }
}
</script>
